import Phaser from "phaser";

interface CodexMonsterSlotOptions {
  monsterId: string;
  textureKey: string;
  discovered: boolean;
  width?: number;
  height?: number;
}

export class CodexMonsterSlot extends Phaser.GameObjects.Container {
  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    options: CodexMonsterSlotOptions,
  ) {
    super(scene, x, y);
    scene.add.existing(this);

    const slotWidth = options.width ?? 128;
    const slotHeight = options.height ?? 128;

    // 발견 여부에 따라 이미지 또는 물음표 텍스트 표시
    if (options.discovered) {
      const image = scene.add.image(0, 0, options.textureKey);
      image.setDisplaySize(slotWidth, slotHeight);
      this.add(image);
    } else {
      const question = scene.add
        .text(0, -10, "?", {
          fontFamily: "Luckiest Guy",
          fontSize: "128px",
          color: "#D8D9DA",
        })
        .setOrigin(0.5);

      this.add([question]);
    }

    // 클릭 영역 설정
    this.setSize(slotWidth, slotHeight);
    this.setInteractive();

    // 클릭 이벤트
    this.on("pointerup", () => {
      if (!options.discovered) {
        // 잠긴 상태면 무시
        return;
      }

      // 이벤트 발행 (씬이 받음)
      this.scene.events.emit("open-monster-detail", {
        monsterId: options.monsterId,
      });
    });
  }
}
